import { Box, Skeleton, Stack, Typography, useTheme } from '@mui/material';

function EmailSummaryCardSkeleton() {
    const theme = useTheme();

    return (
        <Box
            sx={{
                borderTop: `1px solid ${theme.palette.neutral.borderColor}`,
                width: '100%',
                padding: '16px 0px',
            }}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '40px 1fr 165px',
                    gap: '16px',
                }}
            >
                <Skeleton variant="circular" width={40} height={40} />
                <Stack spacing={1}>
                    <Skeleton variant="text" width="45%" height={20} />
                    <Skeleton variant="text" width="55%" height={20} />
                    <Skeleton variant="text" width="70%" height={24} />
                    <Skeleton variant="text" width={180} height={28} />
                    <Skeleton variant="text" width="90%" height={20} />
                    <Skeleton variant="text" width="60%" height={20} />
                    <Skeleton variant="text" width={72} height={20} />
                </Stack>
                <Skeleton variant="text" width={120} height={20} />
            </Box>
        </Box>
    );
}

export default function EmailTimelineSkeleton() {
    const theme = useTheme();

    return (
        <Stack
            spacing={2}
            p={3}
            m={3}
            sx={{
                border: `1px solid ${theme.palette.neutral.borderColor}`,
                borderRadius: '8px',
                backgroundColor: theme.palette.neutral.white,
            }}
        >
            <Typography variant="h3">Email timeline</Typography>
            <EmailSummaryCardSkeleton />
            <EmailSummaryCardSkeleton />
            <EmailSummaryCardSkeleton />
        </Stack>
    );
}
